import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddAutomationBlockModal from 'modules/automations/components/AddAutomationBlockModal'
import type { ITriggerWithConditions } from 'modules/automations/store/models/Trigger'

const AddAutomationBlockModalPage = () => {
  const { navigation } = useNavigation()
  const { id, parentId } = useStrictParams<'id' | 'parentId'>()

  const trigger = useOutletContext<ITriggerWithConditions>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.automations.id.fullPath({ id }))
  }

  return (
    <AddAutomationBlockModal
      onClose={onClose}
      trigger={trigger}
      automationId={Number(id)}
      parentActionId={Number(parentId)}
    />
  )
}

export default AddAutomationBlockModalPage
